module.exports = __webpack_public_path__ + "static/media/thankyoubg.104bef4f.webp";